import { formatDateStringToISOString } from './date';

export const getActRecordVersionByDate = date => {
  if (!date) {
    return 'NEW';
  }

  const dateFieldValue = new Date(formatDateStringToISOString(date)).getTime();
  // 1 октября 2018
  const dateOfChangeNumberFormat = new Date(2018, 9, 1).getTime();

  if (dateFieldValue < dateOfChangeNumberFormat) {
    return 'OLD';
  }

  return 'NEW';
};
